/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Checkbox, Radio } from '@material-ui/core';
import {
  QUESTION_TYPE,
  QUESTION_TRUE,
  QUESTION_FALSE,
} from '../../../shared/utils/constants';

function crateContent(t, onAnswerUpdate, questionType) {
  const type = questionType ? questionType.value : '';
  let columns;
  const textEllipsis = {
    maxWidth: '10rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  if (type === QUESTION_TYPE.OBJECTIVE) {
    columns = [
      {
        field: 'description',
        sorting: false,
        cellStyle: {
          width: 200,
          maxWidth: 200,
        },
        headerStyle: {
          width: 200,
          maxWidth: 200,
        },
      },
      {
        title: t('answers.correct'),
        sorting: false,
        field: 'correct',
        cellStyle: {
          width: 20,
          maxWidth: 20,
        },
        headerStyle: {
          width: 20,
          maxWidth: 20,
        },
        render: (rowData) => (
          <Checkbox
            name="correct"
            checked={rowData.correct}
            onChange={(event, value) => {
              const newData = {
                ...rowData,
                correct: value,
              };
              onAnswerUpdate(rowData, newData);
            }}
          />
        ),
      },
    ];
  } else if (type === QUESTION_TYPE.TRUE_FALSE) {
    columns = [
      { field: 'description', sorting: false },
      {
        title: t('answers.true'),
        sorting: false,
        field: 'trueOrFalse',
        render: (rowData) => (
          <Radio
            checked={rowData.trueOrFalse === QUESTION_TRUE}
            onChange={(event, value) => {
              const newData = {
                ...rowData,
                trueOrFalse: value ? QUESTION_TRUE : QUESTION_FALSE,
              };
              onAnswerUpdate(rowData, newData);
            }}
          />
        ),
      },
      {
        title: t('answers.false'),
        sorting: false,
        field: 'trueOrFalse',
        render: (rowData) => (
          <Radio
            checked={rowData.trueOrFalse === QUESTION_FALSE}
            onChange={(event, value) => {
              const newData = {
                ...rowData,
                trueOrFalse: value ? QUESTION_FALSE : QUESTION_TRUE,
              };
              onAnswerUpdate(rowData, newData);
            }}
          />
        ),
      },
    ];
  } else {
    columns = [
      {
        title: t('general.options'),
        field: 'description',
        sorting: false,
        cellStyle: textEllipsis,
        headerStyle: {
          width: 200,
          maxWidth: 200,
        },
      },
    ];
  }

  return columns;
}

export default function (t, onAnswerUpdate, questionType) {
  return crateContent(t, onAnswerUpdate, questionType);
}
